import React, {Component} from 'react';
import {Row, Alert, Col, Progress, Card, CardHeader,CardBody,Label,Input, Button, Table, Badge, CardTitle, Pagination, PaginationItem, PaginationLink, DropdownMenu,DropdownToggle, ButtonGroup,Dropdown,DropdownItem} from 'reactstrap';
import { ajaxWrapperGet,ajaxWrapperPost } from '../../../../utils/deviceAPI';
import LoadingIndicator from '../../../../utils/LoadingIndicator'
import LaddaButton, {SLIDE_DOWN,CONTRACT_OVERLAY,EXPAND_LEFT} from 'react-ladda';
import DeviceOffline from '../../DeviceMessages/DeviceOffline';
import {isDeviceOnline} from "../../../../utils/isDeviceOnline";
import AppSwitch from '../../../../components/aaaa/tempAppSwitch';


//google maps

class BeaverCreekControl extends Component {
    constructor(props) {
        super(props);
        this.state = { data: [
                {

                    initializer: 0,
                },
                {
                    initializer: 0,
                }

            ],
            loading: true,
            loadingCounter: 0,

        };
        this.masterModeState = this.masterModeState.bind(this);
        this.masterModeConfirmButton = this.masterModeConfirmButton.bind(this);
        this.utilityReXferState = this.utilityReXferState.bind(this);
        this.utilityXferSelectState = this.utilityXferSelectState.bind(this);
        this.immXferConfirmButton = this.immXferConfirmButton.bind(this);
        this.immXferConfirmButtonReset = this.immXferConfirmButtonReset.bind(this);
    }
    componentDidMount() {
        let device = this.props.device;
        ajaxWrapperGet('/api/controlData',device).then((data) => {

            const isdataUndefined = data.reportedData === undefined;

            const mmswA = isdataUndefined ? 0 : data.reportedData.controlMasterModeSwAuto === 1;
            const mmswM = isdataUndefined ? 0 : data.reportedData.controlMasterModeSwManual === 1;
            const mmswX = isdataUndefined ? 0 : data.reportedData.controlMasterModeSwEmerg === 1;

            const urxferA = isdataUndefined ? 0 : data.reportedData.controlUtilRexferSwAuto === 1;
            const urxferM = isdataUndefined ? 0 : data.reportedData.controlUtilRexferSwManual === 1;

            const xferEmergencyN1 = isdataUndefined ? 0 : data.reportedData.controlXfertoEmergSwN1 === 1;
            const xferEmergencyN2 = isdataUndefined ? 0 : data.reportedData.controlXfertoEmergSwN2 === 1;

            const immXferHigh = isdataUndefined ? 0 : data['reportedData']['controlPbImmXfer'] === 1;


            this.setState({
                data,
                loading: false,
                immxferbuttonstate: immXferHigh,
                immxferbuttonClicked: false,
                mmswbuttonstate: false,
                mmswbuttonClicked: false,
                mmswbuttonVisibility: false,
                mastermodeselect: {
                    auto: mmswA,
                    manual: mmswM,
                    xferemergency: mmswX,
                    button: false,
                },
                urxferbuttonstate: false,
                urxferbuttonClicked: false,
                urxferbuttonVisibility: false,
                urxfermodeselect: {
                    auto: urxferA,
                    manual: urxferM,
                    button: false,
                },
                xferEmergencybuttonstate: false,
                xferEmergencybuttonClicked: false,
                xferEmergencybuttonVisibility: false,
                xferEmergencymodeselect: {
                    xferEmergencyN1: xferEmergencyN1,
                    xferEmergencyN2: xferEmergencyN2,
                    button: false,
                }

            });

            if (!isdataUndefined) {
                this.tick();
                this.timerID = setInterval(
                    () => this.tick(),
                    4000
                );
            }
        });



    }

    componentWillUnmount(){
        clearInterval(this.timerID);
    }
    toggle(name) {
        this.setState({
            [name]: !this.state[name],
            progress: 0.5
        })
    }
    tick(device = this.props.device) {
        ajaxWrapperGet('/api/controlData',device).then((data) => {
            let mmswReported = data.reportedData.controlMasterModeSwAuto === 1 ? 1 : data.reportedData.controlMasterModeSwManual === 1 ? 2 : data.reportedData.controlMasterModeSwEmerg === 1 ? 3 : 0;
            let mmswState = this.state.mastermodeselect.auto === true ? 1 : this.state.mastermodeselect.manual === true ? 2 : this.state.mastermodeselect.xferemergency === true ? 3 : false ;

            let rexferReported = data.reportedData.controlUtilRexferSwAuto === 1 ? 1 : data.reportedData.controlUtilRexferSwManual === 1 ? 2 : 0;
            let rexferState = this.state.urxfermodeselect.auto === true ? 1 : this.state.urxfermodeselect.manual === true ? 2 : false ;

            let xferSelectReported = data.reportedData.controlXfertoEmergSwN1 === 1 ? 1 : data.reportedData.controlXfertoEmergSwN2 === 1 ? 2 : 0;
            let xferSelectState = this.state.xferEmergencymodeselect.xferEmergencyN1 === true ? 1 : this.state.xferEmergencymodeselect.xferEmergencyN2 === true ? 2 : false ;

            let immxferbuttonstate = data['reportedData']['controlPbImmXfer'];


            if (this.state.mmswbuttonClicked) {
                if (mmswState === mmswReported) {
                    this.setState({
                        data,
                        mmswbuttonstate: false,
                        mmswbuttonVisibility : false,
                        mmswbuttonClicked: false,

                    });
                }
            }
            if (this.state.urxferbuttonClicked) {
                if (rexferState === rexferReported) {
                    this.setState({
                        data,
                        urxferbuttonstate: false,
                        urxferbuttonVisibility : false,
                        urxferbuttonClicked: false,

                    });
                }
            }
            if (this.state.xferEmergencybuttonClicked) {
                if (xferSelectState === xferSelectReported) {
                    this.setState({
                        data,
                        xferEmergencybuttonstate: false,
                        xferEmergencybuttonVisibility : false,
                        xferEmergencybuttonClicked: false,

                    });
                }
            }
            if (this.state.immxferbuttonClicked) {
                if (!immxferbuttonstate) {
                    this.setState({
                        data,
                        immxferbuttonstate: false,
                        immxferbuttonClicked : false

                    });
                }
            }
            else {

                this.setState({
                    data
                });
            }


        });
    }
    masterModeState(e) {

        if (e.target.id === "MMSWAuto") {
            this.setState({
                mmswbuttonVisibility: !(this.state.data.reportedData.controlMasterModeSwAuto === 1),
                mastermodeselect : {
                    auto: true,
                    manual: false,
                    xferemergency: false
                }
            })
        }
        else if (e.target.id === "MMSWManual") {
            this.setState({
                mmswbuttonVisibility: !(this.state.data.reportedData.controlMasterModeSwManual === 1),
                mastermodeselect : {
                    auto: false,
                    manual: true,
                    xferemergency: false
                }
            })
        }
        else if (e.target.id === "MMSWXfertoEmerg") {
            this.setState({
                mmswbuttonVisibility: !(this.state.data.reportedData.controlMasterModeSwEmerg === 1),
                mastermodeselect : {
                    auto: false,
                    manual: false,
                    xferemergency: true
                }
            })
        }
    }

    utilityReXferState(e) {
        if (e.target.id === "URSWAuto") {
            this.setState({
                urxferbuttonVisibility: !(this.state.data.reportedData.controlUtilRexferSwAuto === 1),
                urxfermodeselect : {
                    auto: true,
                    manual: false
                }
            })
        }
        else if (e.target.id === "URSWManual") {
            this.setState({
                urxferbuttonVisibility: !(this.state.data.reportedData.controlUtilRexferSwManual === 1),
                urxfermodeselect : {
                    auto: false,
                    manual: true
                }
            })
        }
    }

    utilityXferSelectState(e) {
        if (e.target.id === "UXFS1") {
            this.setState({
                xferEmergencybuttonVisibility: !(this.state.data.reportedData.controlXfertoEmergSwN1 === 1),
                xferEmergencymodeselect : {
                    xferEmergencyN1: true,
                    xferEmergencyN2: false
                }
            })
        }
        else if (e.target.id === "UXFS2") {
            this.setState({
                xferEmergencybuttonVisibility: !(this.state.data.reportedData.controlXfertoEmergSwN2 === 1),
                xferEmergencymodeselect : {
                    xferEmergencyN1: false,
                    xferEmergencyN2: true
                }
            })
        }
    }

    masterModeConfirmButton() {
        let postData = {
            controlMasterModeSwAuto: this.state.mastermodeselect.auto,
            controlMasterModeSwManual: this.state.mastermodeselect.manual,
            controlMasterModeSwEmerg: this.state.mastermodeselect.xferemergency,
        };
        ajaxWrapperPost(`/api/controlData?dev=${this.props.device}`,postData).then((data) => {
            this.setState({
                mmswbuttonClicked: true
            })
        });
    }

    utilityRexferConfirmButton() {
        let postData = {
            controlUtilRexferSwAuto: this.state.urxfermodeselect.auto,
            controlUtilRexferSwManual: this.state.urxfermodeselect.manual
        };

        ajaxWrapperPost(`/api/controlData?dev=${this.props.device}`,postData).then((data) => {
            this.setState({
                urxferbuttonClicked: true
            })
        });
    }

    utilityXferSelectConfirmButton() {
        let postData = {
            controlXfertoEmergSwN1: this.state.xferEmergencymodeselect.xferEmergencyN1,
            controlXfertoEmergSwN2: this.state.xferEmergencymodeselect.xferEmergencyN2
        };

        ajaxWrapperPost(`/api/controlData?dev=${this.props.device}`,postData).then((data) => {
            this.setState({
                xferEmergencybuttonClicked: true
            })
        });
    }

    immXferConfirmButton() {
        let postData = {
            controlPbImmXfer: true
        };

        ajaxWrapperPost(`/api/controlData?dev=${this.props.device}`,postData).then((data) => {
            this.setState({
                immxferbuttonClicked: true
            })
        });
    }

    immXferConfirmButtonReset() {
        let postData = {
            controlPbImmXfer: false
        };

        ajaxWrapperPost(`/api/controlData?dev=${this.props.device}`,postData).then((data) => {
            this.setState({
                immxferbuttonClicked: true
            })
        });
    }

    render() {
        const { data } = this.state;
        if (this.state.loading) {
            return <LoadingIndicator />;
        }

        if (data.error === true) {
            this.props.history.replace('/verify');
            return <LoadingIndicator />;
        }
        const reportedControlState = data.reportedData;
        const systemStatus = data.systemStatus;

        const reportedMasterModeSelector = reportedControlState.controlMasterModeSwAuto === 1 ? "Auto" : reportedControlState.controlMasterModeSwManual === 1 ? "Manual" : reportedControlState.controlMasterModeSwEmerg === 1 ? "Transfer to Emergency" : "Unknown";
        const reportedUtilityRexferSelector = reportedControlState.controlUtilRexferSwAuto === 1 ? "Auto" : reportedControlState.controlUtilRexferSwManual === 1 ? "Manual" : "Unknown";
        const reportedUtilityxferSelectorSelector = reportedControlState.controlXfertoEmergSwN1 === 1 ? "Utility 1" : reportedControlState.controlXfertoEmergSwN2 === 1 ? "Utility 2" : "Unknown";

        const immXferHigh = reportedControlState['controlPbImmXfer'] === 1;

        let systemGenWarmup = data['reportedData']['systemGenWarmup'];
        let systemN1Exit = data['reportedData']['systemN1Exit'];
        let systemN2Exit = data['reportedData']['systemN2Exit'];


        if (data.error === false) {
            return (
                <div className="containerAnimation">
                    <div className="fadeInUp">
                    <Row>
                        <Col xs="12" sm="12" lg="12" xl="12">
                            <Card>
                                <CardBody className="card-body">
                                    <Row className="pb-2">
                                        <Col sm="12">
                                            <CardTitle className="mb-0">System Status</CardTitle>
                                            <div className="small text-muted">Current status of the system, switches and timers</div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col sm="12">
                                            <ul className="icons-list mb-3 list-inline">
                                                {systemStatus.map(function(alarm,index){
                                                    if (alarm.message !== "-" && alarm.status === 1) return (
                                                        <li key={index} className="mb-3 mt-3 listSiteItems">
                                                            <i className={"fa fa-check-square-o " + (alarm.status === 1 ? "text-success" : "text-danger")}></i>
                                                            <div className="desc-n">
                                                                <div className="title">{alarm.message}</div>
                                                                <div className="small text-muted text-lowercase pb-3">status</div>
                                                            </div>
                                                        </li>
                                                    );
                                                })}
                                                {Math.floor(systemGenWarmup / 100) <= 4 ?
                                                    <li className="mb-3 mt-3 listSiteItems">
                                                        <i className="fa fa-clock-o text-warning"></i>
                                                        <div className="desc-n">
                                                            <div className="title">Gen Warmup Timer - {systemGenWarmup / 100} minutes/seconds</div>
                                                            <div className="small text-muted text-lowercase pb-3">timer</div>
                                                        </div>
                                                    </li>
                                                    : ""
                                                }
                                                {Math.floor(systemN1Exit / 100) <= 14 ?
                                                    <li className="mb-3 mt-3 listSiteItems">
                                                        <i className="fa fa-clock-o text-warning"></i>
                                                        <div className="desc-n">
                                                            <div className="title">Utility 1 Retransfer - {systemN1Exit / 100} minutes/seconds</div>
                                                            <div className="small text-muted text-lowercase pb-3">timer</div>
                                                        </div>
                                                    </li>
                                                    : ""
                                                }
                                                {Math.floor(systemN2Exit / 100) <= 14 ?
                                                    <li className="mb-3 mt-3 listSiteItems">
                                                        <i className="fa fa-clock-o text-warning"></i>
                                                        <div className="desc-n">
                                                            <div className="title">Utility 1 Retransfer - {systemN2Exit / 100} minutes/seconds</div>
                                                            <div className="small text-muted text-lowercase pb-3">timer</div>
                                                        </div>
                                                    </li>
                                                    : ""
                                                }
                                            </ul>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs="12" lg="12" xl="6">
                            <Card className="">
                                <CardHeader>
                                    Immediate Transfer
                                </CardHeader>
                                <CardBody className="card-body">
                                    {immXferHigh ?
                                        <Row>
                                            <Col xs="12">
                                                <Alert color="warning">
                                                    Immidiate Transfer is currently active.
                                                </Alert>
                                            </Col>
                                        </Row> : ""}
                                    <Row>
                                        <Col xs="12" sm="6" lg="6">
                                            <LaddaButton
                                                className="btn btn-danger btn-ladda btn-block"
                                                loading={this.state.immxferbuttonstate}
                                                onClick={() => {this.immXferConfirmButton();this.toggle('immxferbuttonstate');}}
                                                data-color="red"
                                                data-style={EXPAND_LEFT}
                                            >
                                                {immXferHigh ? "Immediate Transfer" : "Immediate Transfer" }
                                            </LaddaButton>

                                        </Col>
                                        <Col xs="12" sm="6" lg="6">
                                            <Button color="primary" className="btn btn-block" onClick={() => {this.immXferConfirmButtonReset();this.toggle('immxferbuttonstate');}} disabled={!immXferHigh}>Reset</Button>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs="12" lg="12" xl="6">
                            <Card className="">
                                <CardHeader>
                                    Master Mode Selector
                                </CardHeader>
                                <CardBody className="card-body">
                                    <Row>
                                        <Col xs="6" sm="6" lg="6">
                                            <div className="text-muted text-uppercase font-weight-normal font-xs">Auto</div>
                                        </Col>
                                        <Col xs="3" sm="3" lg="3">
                                            <Label className="switch switch-icon switch-danger-outline">
                                                <AppSwitch className={'mx-1'} color={'danger'} label id="MMSWAuto" onChange={this.masterModeState} checked={this.state.mastermodeselect.auto}  disabled={this.state.mastermodeselect.auto} />
                                            </Label>
                                        </Col>
                                        <Col xs="3" sm="3" lg="3">
                                            {reportedMasterModeSelector === "Auto" ? <Badge color="success">Remote</Badge> : ""}
                                        </Col>
                                    </Row>
                                    <hr/>
                                    <Row>
                                        <Col xs="6" sm="6" lg="6">
                                            <div className="text-muted text-uppercase font-weight-normal font-xs">Manual</div>
                                        </Col>
                                        <Col xs="3" sm="3" lg="3">
                                            <Label className="switch switch-icon switch-danger-outline">
                                                <AppSwitch className={'mx-1'} color={'danger'} label id="MMSWManual" onChange={this.masterModeState} checked={this.state.mastermodeselect.manual}  disabled={this.state.mastermodeselect.manual}/>
                                            </Label>
                                        </Col>
                                        <Col xs="3" sm="3" lg="3">
                                            {reportedMasterModeSelector === "Manual" ? <Badge color="success">Remote</Badge> : ""}
                                        </Col>
                                    </Row>
                                    <hr/>

                                    <Row>
                                        <Col xs="6" sm="6" lg="6">
                                            <div className="text-muted text-uppercase font-weight-normal font-xs">Transfer to Emergency</div>
                                        </Col>
                                        <Col xs="3" sm="3" lg="3">
                                            <Label className="switch switch-icon switch-danger-outline">
                                                <AppSwitch className={'mx-1'} color={'danger'} label id="MMSWXfertoEmerg" onChange={this.masterModeState} checked={this.state.mastermodeselect.xferemergency} disabled={this.state.mastermodeselect.xferemergency}/>
                                            </Label>
                                        </Col>
                                        <Col xs="3" sm="3" lg="3">
                                            {reportedMasterModeSelector === "Transfer to Emergency" ? <Badge color="success">Remote</Badge> : ""}
                                        </Col>
                                    </Row>
                                    <hr/>
                                    <Row>
                                        <Col xs="12" sm="6" lg="6">

                                            <LaddaButton
                                                className="btn btn-danger btn-ladda btn-block"
                                                loading={this.state.mmswbuttonstate}
                                                onClick={() => {this.masterModeConfirmButton();this.toggle('mmswbuttonstate');}}
                                                data-color="red"
                                                data-style={EXPAND_LEFT}
                                                disabled={!this.state.mmswbuttonVisibility}
                                            >
                                                Confirm
                                            </LaddaButton>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>

                        <Col xs="12" lg="12" xl="6">
                            <Card className="">
                                <CardHeader>
                                    Utility Retransfer Selector
                                </CardHeader>
                                <CardBody className="card-body">
                                    <Row>
                                        <Col xs="6" sm="6" lg="6">
                                            <div className="text-muted text-uppercase font-weight-normal font-xs">Auto</div>
                                        </Col>
                                        <Col xs="3" sm="3" lg="3">
                                            <Label className="switch switch-icon switch-danger-outline">
                                                <AppSwitch className={'mx-1'} color={'danger'} label id="URSWAuto" onChange={this.utilityReXferState} checked={this.state.urxfermodeselect.auto} disabled={this.state.urxfermodeselect.auto}/>
                                            </Label>
                                        </Col>
                                        <Col xs="3" sm="3" lg="3">
                                            {reportedUtilityRexferSelector === "Auto" ? <Badge color="success">Remote</Badge> : ""}
                                        </Col>
                                    </Row>
                                    <hr/>
                                    <Row>
                                        <Col xs="6" sm="6" lg="6">
                                            <div className="text-muted text-uppercase font-weight-normal font-xs">Manual</div>
                                        </Col>
                                        <Col xs="3" sm="3" lg="3">
                                            <Label className="switch switch-icon switch-danger-outline">
                                                <AppSwitch className={'mx-1'} color={'danger'} label id="URSWManual" onChange={this.utilityReXferState} checked={this.state.urxfermodeselect.manual} disabled={this.state.urxfermodeselect.manual}/>
                                            </Label>
                                        </Col>
                                        <Col xs="3" sm="3" lg="3">
                                            {reportedUtilityRexferSelector === "Manual" ? <Badge color="success">Remote</Badge> : ""}
                                        </Col>
                                    </Row>
                                    <hr/>
                                    <Row>
                                        <Col xs="6" sm="6" lg="6">
                                            {this.state.urxferbuttonVisibility ?
                                                <LaddaButton
                                                    className="btn btn-danger btn-ladda"
                                                    loading={this.state.urxferbuttonstate}
                                                    onClick={() => {this.utilityRexferConfirmButton();this.toggle('urxferbuttonstate');}}
                                                    data-color="red"
                                                    data-style={EXPAND_LEFT}
                                                >
                                                    Confirm
                                                </LaddaButton> : ""}
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>

                    </Row>
                </div>
                </div>
            )
        }

        else {
            return (
                <div className="animated fadeIn">
                    <Row>
                        <Col xs="12" lg="12">
                            <Card className="text-white bg-danger text-center">
                                <CardBody className="card-body">
                                    <blockquote className="card-bodyquote">
                                        <p>Something went wrong with the server. Please refresh your browser. If the problem persists, please contact our support desk.</p>
                                    </blockquote>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </div>


            )
        }


    }
}
export default BeaverCreekControl;



// WEBPACK FOOTER //
// ./src/views/site/Control/Templates/BeaverCreek.js